// AUTH-38 / UI-09: the signed-in user, read from the session cookie at the moment of the call - never once when a
// file first loads (that kept the previous user's role after logging in as someone else without a reload).
import Cookies from "js-cookie";

export const currentUser = () => {
  try {
    return JSON.parse(Cookies.get("user") || "null");
  } catch (e) {
    return null;
  }
};

export const currentRoleId = () => currentUser()?.role_id ?? null;
